import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormat } from '@agilox/ui-common';

@Pipe({
	name: 'timePickerHour',
})
export class TimePickerHourPipe implements PipeTransform {
	transform(value: string | undefined, format: TimeFormat): any {
		if (!value) {
			return format === TimeFormat.TWELVE_HOUR ? '12' : '00';
		}
		if (format === TimeFormat.TWELVE_HOUR) {
			if (Number(value.split(':')[0]) === 0) {
				return '12';
			}
			if (Number(value.split(':')[0]) > 12) {
				return String(Number(value.split(':')[0]) - 12).padStart(2, '0');
			}
		}
		return value.split(':')[0].padStart(2, '0');
	}
}
